import * as React from 'react';
import * as autoBind from 'react-autobind';
import ReviewerGroupModel from '../../types/ReviewerGroupModel';
import {ReactElement} from 'react';
import Strings from '../../globals/Strings';
import Constants from '../../globals/Constants';

export default class GroupsMenu extends React.Component<GroupsMenuProps, {}> {
   constructor(props: GroupsMenuProps) {
      super(props);
      autoBind(this);
   }

   getGroupDiv(reviewerGroup: ReviewerGroupModel, index: number): ReactElement<any> {
      const onClick = () => {
         this.props.addEmails(reviewerGroup.GroupMembers.map(members => members.Email));
      };

      const onKeyPress = (e: any) => {
         if (e.keyCode === Constants.keys.enter && !e.shiftKey) {
            onClick();
         }
      };

      const strings = Strings.labels.groupsMenu;
      const countText = reviewerGroup.GroupMembers.length === 1 ? strings.oneMember : strings.members;

      return <div className="group-list-spacing" onClick={onClick} onKeyDown={e => onKeyPress(e)} key={index} tabIndex={0} role="button" aria-label={reviewerGroup.GroupName}>
         <div className="group-name">
            {reviewerGroup.GroupName}
         </div>
         <div className="group-count">
            {countText.replace('{param0}', reviewerGroup.GroupMembers.length + '')}
         </div>
      </div>;
   }

   render() {
      const {reviewerGroups} = this.props;

      return (
         <div className="group-menu">
            {reviewerGroups.length && reviewerGroups.map((group, index) => this.getGroupDiv(group, index))}
         </div>
      );
   }
}

export interface GroupsMenuProps {
   reviewerGroups: ReviewerGroupModel[];
   addEmails(emails: string[]): void;
}
